var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 36,
  width: 39,
  height: 1.5,
  rx: 0.75,
  fill: "#c3ccd2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m23.5 15.5a9.8 9.8 0 0 1 19.6 0z",
  fill: "#e0704f"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m23.5 15.5a9.8 9.8 0 0 1 19.6 0z",
  fill: "none"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 26.8,
  cy: 15.5,
  r: 1.6,
  fill: "#e0704f"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 33.3,
  cy: 15.5,
  r: 1.6,
  fill: "#e0704f"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 39.8,
  cy: 15.5,
  r: 1.6,
  fill: "#e0704f"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 32.6,
  y: 15.5,
  width: 1.4,
  height: 20.5,
  fill: "#8a6238"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m10 12.5c-0.9-1.4 0.9-2.2 0-3.6",
  fill: "none",
  stroke: "#c3ccd2",
  strokeWidth: 1.1,
  strokeLinecap: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m14.5 12.5c-0.9-1.4 0.9-2.2 0-3.6",
  fill: "none",
  stroke: "#c3ccd2",
  strokeWidth: 1.1,
  strokeLinecap: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 12.3,
  cy: 14.6,
  r: 1,
  fill: "#5c6870"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m5.1 22a7.2 7.2 0 0 1 14.4 0z",
  fill: "#3f4a54"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m5.1 22h14.4c0 4-3.1 6.6-7.2 6.6s-7.2-2.6-7.2-6.6z",
  fill: "#333a40"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m9.5 28.5-1.8 7.5",
  fill: "none",
  stroke: "#5c6870",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "m15.1 28.5 1.8 7.5",
  fill: "none",
  stroke: "#5c6870",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  cx: 7.4,
  cy: 36,
  r: 1.6,
  fill: "#5c6870"
});

function SvgBbqGrillPatio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbqGrillPatio);
export default __webpack_public_path__ + "static/media/bbq-grill-patio.25359f99b8acbb620ea117e511bef718.svg";
export { ForwardRef as ReactComponent };